import { ReactElement, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";

import styles from "./index.module.css";
import { useNavigate } from "../../lib/navigate";
import { useKeyboardShortcuts } from "../../lib/keyboard";
import { useDrawings } from "../../state/drawings";
import { useGridColCount } from "../../lib/dom";
import IconButton from "../shared/Icon/Button";
import Tooltip from "../shared/Tooltip";
import Header from "../shared/Header";
import Thumbnail from "../shared/Preview";

export default function Gallery(): ReactElement {
  const { drawings, create } = useDrawings();
  const navigate = useNavigate();

  function newDrawing(): void {
    requestAnimationFrame(() => {
      const id = create();
      navigate(`/edit/${id}`);
    });
  }

  const colCount = useGridColCount();
  function calcPreviewSize(colCount: number): string {
    return `calc((100vw - ${colCount + 1} * var(--gutter)) / ${colCount})`;
  }
  const [previewSize, setPreviewSize] = useState(calcPreviewSize(colCount));
  useLayoutEffect(() => setPreviewSize(calcPreviewSize(colCount)), [colCount]);

  useKeyboardShortcuts({
    new: () => newDrawing(),
    settings: () => navigate("/settings"),
  });

  return (
    <>
      <Tooltip />

      <div className={styles.wrapper}>
        <Header
          nav={<IconButton name="new" tooltip="new" onClick={newDrawing} />}
          title={"kare.pkg"}
          menu={
            <IconButton
              name="settings"
              onClick={() => navigate("/settings")}
              tooltip="settings"
            />
          }
        />

        <div
          className={styles.gallery}
          style={{
            gridTemplateColumns: `repeat(${colCount}, 1fr)`,
          }}
        >
          {drawings.map((drawing) => (
            <div className={styles.preview} key={drawing.id}>
              <Link
                to={`edit/${drawing.id}`}
                style={{
                  width: previewSize,
                  height: previewSize,
                }}
              >
                <Thumbnail preview={drawing.preview} opaque={true} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
